import { useChain, usePortfolio } from 'contexts';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PortfolioTableRow from './PortfolioTableRow';

const PortfolioTable = () => {
  const { t } = useTranslation();
  const { styleSlug } = useChain();
  const {
    walletBalance,
    walletBalanceTotalUsd,
    whirlpoolBalanceCurrency,
    whirlpoolBalanceTotalUsd,
    surf3dBalanceCurrency,
    surf3dBalanceTotalUsd,
    beachBalanceCurrency,
    beachBalanceTotalUsd,
    polywaveBalanceCurrency,
    polywaveBalanceTotalUsd,
  } = usePortfolio();

  return (
    <table className="w-full table-fixed text-lg text-left">
      <thead className={`uppercase text-${styleSlug}-primary dark:text-${styleSlug}-light`}>
        <tr>
          <th className="pb-2 font-normal">{t('portfolio.source')}</th>
          <th className="pb-2 font-normal text-right md:text-left">{t('portfolio.quantity')}</th>
          <th className="pb-2 font-normal text-right hidden md:table-cell">
            {t('portfolio.percentage')}
          </th>
          <th className="pb-2 font-normal text-right hidden md:table-cell">
            {t('portfolio.balance')}
          </th>
        </tr>
      </thead>
      <tbody>
        <PortfolioTableRow
          source={t('portfolio.balance_chart.wallet')}
          balance={walletBalance}
          balanceTotalUsd={walletBalanceTotalUsd}
        />
        <PortfolioTableRow
          source={t('portfolio.balance_chart.whirlpool')}
          balance={whirlpoolBalanceCurrency}
          balanceTotalUsd={whirlpoolBalanceTotalUsd}
        />
        <PortfolioTableRow
          source={t('portfolio.balance_chart.surf3d')}
          balance={surf3dBalanceCurrency}
          balanceTotalUsd={surf3dBalanceTotalUsd}
        />

        <PortfolioTableRow
          source={t('portfolio.balance_chart.beach')}
          balance={beachBalanceCurrency}
          balanceTotalUsd={beachBalanceTotalUsd}
        />

        <PortfolioTableRow
          source={t('portfolio.balance_chart.polywave')}
          balance={polywaveBalanceCurrency}
          balanceTotalUsd={polywaveBalanceTotalUsd}
        />
      </tbody>
    </table>
  );
};

export default PortfolioTable;
